import { platformAppArtwork, platformConsultingArtwork } from './platform-landing/platform-artwork';

// Reuse Mission Control's artwork and icons from platform-landing/.
// Bounds use the artwork's viewBox (420 200 3000 1680), including its outlined labels.
export const platformTools = [
  {
    ...platformAppArtwork.compliance,
    available: true,
    bounds: [1677, 897, 393, 525],
  },
  {
    ...platformAppArtwork.hazwaste,
    available: false,
    bounds: [2004, 291, 619, 224],
  },
  {
    ...platformAppArtwork.tierii,
    available: true,
    bounds: [2714, 636, 348, 245],
  },
  { ...platformAppArtwork.tri, available: true, bounds: [2833, 1130, 407, 231] },
  {
    ...platformConsultingArtwork,
    available: false,
    bounds: [2282, 1553, 607, 211],
  },
  {
    ...platformAppArtwork.parsing,
    available: true,
    bounds: [1131, 1520, 571, 320],
  },
  {
    ...platformAppArtwork.emissions,
    available: true,
    bounds: [600, 981, 387, 410],
  },
  {
    ...platformAppArtwork.determinations,
    available: true,
    bounds: [943, 480, 779, 227],
  },
] as const;

export type PlatformTool = (typeof platformTools)[number];

export type SpriteRegion = { x: number; y: number; width: number; height: number };

export function platformToolForHostname(hostname: string): PlatformTool | null {
  const subdomain = hostname
    .toLowerCase()
    .split('.')[0]
    .replace(/-test$/, '');
  return platformTools.find((tool) => tool.app === subdomain || tool.svgPrefix === subdomain) ?? null;
}
